import {
	EuiTable,
	EuiTableHeader,
	EuiTableHeaderCell,
	EuiTableBody,
	EuiTableRow,
	EuiTableRowCell,
} from '@equipmentshare/ds2'

import { Rental } from '../RentalsPopover'
import RentalId from './components/RentalId'

export type RentalsTableProps = {
	rentals: Rental[],
}


export default function RentalsTable( { rentals }: RentalsTableProps ) {
	return (
		<EuiTable tableLayout="auto">
			<EuiTableHeader>
				<EuiTableHeaderCell>Rental ID</EuiTableHeaderCell>
				<EuiTableHeaderCell>Qty</EuiTableHeaderCell>
			</EuiTableHeader>
			<EuiTableBody>
				{ rentals.map( ( r ) => (
					<EuiTableRow key={`rental-${r.id}`}>
						<EuiTableRowCell valign="top">
							<RentalId rental={r} />
						</EuiTableRowCell>
						<EuiTableRowCell valign="top">{r.quantityOnRent}</EuiTableRowCell>
					</EuiTableRow>
				) )}
			</EuiTableBody>
		</EuiTable>
	)
}
